import { CalendarOff, Settings2 } from "lucide-react";
import { useLanguage } from "../../../contexts/LanguageContext";
import { settingsLabels } from "../labels";
import { Button } from "../../../components/ui/button";
import { SectionCard } from "../../../components/SectionCard";
import { navigate } from "../../../lib/router";

export function ScheduleExceptionsSection() {
  const { lang } = useLanguage();
  const t = settingsLabels[lang].exceptions;

  return (
    <SectionCard
      header={
        <div className="flex items-center gap-2 font-semibold">
          <CalendarOff className="h-5 w-5 text-neutral-500" />
          {t.header}
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-neutral-500">
          {t.sectionDescription}
        </p>
        <Button 
          className="w-full justify-between" 
          variant="outline"
          onClick={() => navigate("/app/settings/exceptions")}
        >
          {t.new}
          <Settings2 className="h-4 w-4 ml-2 text-neutral-400" />
        </Button>
      </div>
    </SectionCard>
  );
}
